<template>
  <div>
    <v-card class="pa-2">
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <v-form @submit.prevent="handleSubmit(submitForm)">
          <div class="mx-3">
            <v-row class="mt-3">
              <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="py-0">
                <p class="app-title-small text-sm ma-0">
                  Nama Ayah
                </p>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Nama Ayah"
                  rules="required"
                >
                  <v-text-field
                    v-model="fathername"
                    single-line
                    :disabled="showEdit === false"
                    :error-messages="errors"
                    dense
                    outlined
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="py-0">
                <p class="app-title-small text-sm ma-0">
                  Tanggal Lahir Ayah <span class="text-green">(Optional)</span>
                </p>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Tanggal Lahir Ayah"
                      rules=""
                    >
                      <v-text-field
                        v-model="fatherdate"
                        append-icon="mdi-calendar"
                        :error-messages="errors"
                        readonly
                        single-line
                        dense
                        :filled="showEdit === false"
                        outlined
                        v-on="on"
                      ></v-text-field>
                    </ValidationProvider>
                  </template>
                  <v-date-picker
                    v-model="fatherdate"
                    :disabled="showEdit === false"
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6" lg="6" md="6" sm="6" xs="6" class="py-0">
                <p class="app-title-small text-sm ma-0">
                  Status tanggungan Ayah
                </p>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Status tanggungan Ayah"
                  rules="required"
                >
                  <v-select
                    dense
                    :items="leavingList"
                    :error-messages="errors"
                    item-text="text"
                    item-value="id"
                    v-model="dependentFather"
                    :disabled="showEdit === false"
                    outlined
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col cols="6" lg="6" md="6" sm="6" xs="6" class="py-0">
                <p class="app-title-small text-sm ma-0">
                  Sudah Meninggal?
                </p>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Alive"
                  rules="required"
                >
                  <v-select
                    dense
                    :items="aliveList"
                    :error-messages="errors"
                    item-text="text"
                    item-value="id"
                    v-model="aliveFather"
                    :disabled="showEdit === false"
                    outlined
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col
                cols="12"
                lg="12"
                md="12"
                sm="12"
                xs="12"
                class="py-0 mt-5"
              >
                <p class="app-title-small text-sm ma-0">
                  Alamat Ayah <span class="text-green">(Optional)</span>
                </p>
                <ValidationProvider v-slot="{ errors }" name="Alamat">
                  <v-text-field
                    label="address"
                    placeholder="Eg. JL. Cibiru no.1"
                    v-model="addressFather"
                    :error-messages="errors"
                    single-line
                    :disabled="showEdit === false"
                    dense
                    outlined
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="py-0">
                <p class="app-title-small text-sm ma-0">
                  Nama Ibu
                </p>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Nama Ibu"
                  rules="required"
                >
                  <v-text-field
                    v-model="mothername"
                    single-line
                    :error-messages="errors"
                    :disabled="showEdit === false"
                    dense
                    outlined
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="py-0">
                <p class="app-title-small text-sm ma-0">
                  Tanggal Lahir Ibu <span class="text-green">(Optional)</span>
                </p>
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Tanggal Lahir Ibu"
                      rules=""
                    >
                      <v-text-field
                        v-model="motherdate"
                        append-icon="mdi-calendar"
                        :error-messages="errors"
                        readonly
                        single-line
                        dense
                        :filled="showEdit === false"
                        outlined
                        v-on="on"
                      ></v-text-field>
                    </ValidationProvider>
                  </template>
                  <v-date-picker
                    v-model="motherdate"
                    :disabled="showEdit === false"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6" lg="6" md="6" sm="6" xs="6" class="py-0">
                <p class="app-title-small text-sm ma-0">
                  Status tanggungan Ibu
                </p>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Status tanggungan Ibu"
                  rules="required"
                >
                  <v-select
                    dense
                    :items="leavingList"
                    :error-messages="errors"
                    item-text="text"
                    item-value="id"
                    v-model="dependentMother"
                    :disabled="showEdit === false"
                    outlined
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col cols="6" lg="6" md="6" sm="6" xs="6" class="py-0">
                <p class="app-title-small text-sm ma-0">
                  Sudah Meninggal?
                </p>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Mother Alive"
                  rules="required"
                >
                  <v-select
                    dense
                    :items="aliveList"
                    :error-messages="errors"
                    item-text="text"
                    item-value="id"
                    v-model="aliveMother"
                    :disabled="showEdit === false"
                    outlined
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col
                cols="12"
                lg="12"
                md="12"
                sm="12"
                xs="12"
                class="py-0 mt-5"
              >
                <p class="app-title-small text-sm ma-0">
                  Alamat Ibu <span class="text-green">(Optional)</span>
                </p>
                <ValidationProvider v-slot="{ errors }" name="Alamat Ibu">
                  <v-text-field
                    label="address"
                    placeholder="Eg. JL. Cibiru no.1, kel: Cibiru, kec: Cileunyi, bandung, jawa barat indonesia, 14045"
                    v-model="addressmother"
                    :error-messages="errors"
                    single-line
                    :disabled="showEdit === false"
                    dense
                    outlined
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <!--
                <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="py-0">
                  <p class="app-title-small text-sm ma-0">
                    Provinsi Ibu
                  </p>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Provinsi Ibu"
                    rules="required_if: isRequired,true"
                  >
                    <v-autocomplete
                      dense
                      v-model="stateMother"
                      :items="listProvinsi"
                      item-text="state"
                      item-value="state"
                      :disabled="showEdit === false"
                      placeholder="Ketik untuk mencari ...."
                      :error-messages="errors"
                      outlined
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="py-0">
                  <p class="app-title-small text-sm ma-0">
                    Kota Ibu
                  </p>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Kota Ibu"
                    rules="required_if: isRequired,true"
                  >
                    <v-autocomplete
                      dense
                      v-model="cityMother"
                      :items="listCity"
                      item-text="city"
                      item-value="city"
                      :disabled="stateMother === null || showEdit === false"
                      placeholder="Ketik untuk mencari ...."
                      :error-messages="errors"
                      outlined
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="py-0">
                  <p class="app-title-small text-sm ma-0">
                    Kecamatan Ibu
                  </p>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Kecamatan Ibu"
                    rules="required_if: isRequired,true"
                  >
                    <v-autocomplete
                      dense
                      v-model="districtMother"
                      :items="listDistrict"
                      item-text="district"
                      item-value="district"
                      ref="kecamatan"
                      :disabled="cityMother === null || showEdit === false"
                      placeholder="Ketik untuk mencari ...."
                      :error-messages="errors"
                      outlined
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="py-0">
                  <p class="app-title-small text-sm ma-0">
                    Kelurahan Ibu
                  </p>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Kelurahan Ibu"
                    rules="required_if: isRequired,true"
                  >
                    <v-autocomplete
                      dense
                      v-model="subdistrictMother"
                      :items="listSubDistrict"
                      ref="kelurahan"
                      item-text="sub_district"
                      :disabled="districtMother === null || showEdit === false"
                      return-object
                      placeholder="Ketik untuk mencari ...."
                      :error-messages="errors"
                      outlined
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>
                <v-col cols="6" lg="4" md="4" sm="4" xs="6" class="py-0">
                  <p class="app-title-small text-sm ma-0">
                    Kode Pos Ibu
                  </p>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Kode Pos Ibu"
                    rules="required"
                    v-if="subdistrictMother != null"
                  >
                    <v-text-field
                      v-model="subdistrictMother.zip_code"
                      :error-messages="errors"
                      single-line
                      disabled
                      dense
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                  <p v-else class="text-yellow pt-2">
                    Silahkan isi terlebih dahulu kelurahan
                  </p>
                </v-col>
                <v-col cols="6" lg="4" md="4" sm="4" xs="6" class="py-0">
                  <p class="app-title-small text-sm ma-0">
                    RT Ibu
                  </p>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="RT Ibu"
                    rules="required|digits:3"
                  >
                    <v-text-field
                      v-model="rtMother"
                      :error-messages="errors"
                      single-line
                      :disabled="showEdit === false"
                      dense
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="6" lg="4" md="4" sm="4" xs="6" class="py-0">
                  <p class="app-title-small text-sm ma-0">
                    RW Ibu
                  </p>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="RW ibu"
                    rules="required|digits:3"
                  >
                    <v-text-field
                      v-model="rwMother"
                      :error-messages="errors"
                      single-line
                      :disabled="showEdit === false"
                      dense
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-col> -->
              <v-col
                cols="12"
                lg="12"
                md="12"
                sm="12"
                xs="12"
                class="d-flex flex-row py-0 ma-3"
              >
                <p class="app-title-small text-sm">
                  Apakah Anda Sudah Menikah?
                </p>
                <v-btn
                  @click.prevent="switch1 = true"
                  color="primary"
                  class="text-center mx-1"
                  dark
                  :outlined="!switch1"
                  rounded
                  disabled
                  x-small
                >
                  <span class="text-capitalize">Ya</span>
                </v-btn>
                <v-btn
                  @click.prevent="switch1 = false"
                  color="#008ef8"
                  class="text-center mx-1"
                  dark
                  :outlined="switch1"
                  rounded
                  disabled
                  x-small
                >
                  <span class="text-capitalize">Tidak</span>
                </v-btn>
              </v-col>
              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="py-0">
                <div v-if="switch1">
                  <v-row>
                    <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="py-0">
                      <p class="app-title-small text-sm ma-0">
                        Nama
                        <span
                          class="app-title-small text-sm ma-0"
                          v-if="resultKaryawan.gender === 'Laki-laki'"
                          >Istri</span
                        ><span
                          class="app-title-small text-sm ma-0"
                          v-if="resultKaryawan.gender === 'Perempuan'"
                          >Suami</span
                        ><span class="app-title-small text-sm ma-0" v-else
                          >Suami/Istri</span
                        >
                      </p>
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="Nama pasangan"
                        rules="required"
                      >
                        <v-text-field
                          v-model="wifename"
                          single-line
                          :disabled="showEdit === false"
                          :error-messages="errors"
                          dense
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" lg="6" md="6" sm="6" xs="12" class="py-0">
                      <p class="app-title-small text-sm ma-0">
                        Tanggal Lahir
                        <span
                          class="app-title-small text-sm ma-0"
                          v-if="resultKaryawan.gender === 'Laki-laki'"
                          >Istri</span
                        ><span
                          class="app-title-small text-sm ma-0"
                          v-if="resultKaryawan.gender === 'Perempuan'"
                          >Suami</span
                        ><span class="app-title-small text-sm ma-0" v-else
                          >Suami/Istri</span
                        >
                      </p>
                      <v-menu
                        v-model="menu3"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Tanggal Lahir Suami atau Istri"
                            rules="required"
                          >
                            <v-text-field
                              v-model="wifedate"
                              append-icon="mdi-calendar"
                              :error-messages="errors"
                              readonly
                              single-line
                              dense
                              :filled="showEdit === false"
                              outlined
                              v-on="on"
                            ></v-text-field>
                          </ValidationProvider>
                        </template>
                        <v-date-picker
                          v-model="wifedate"
                          :disabled="showEdit === false"
                          @input="menu3 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="6" lg="6" md="6" sm="6" xs="6" class="">
                      <p class="app-title-small text-sm ma-0">
                        Status tanggungan
                        <span
                          class="app-title-small text-sm ma-0"
                          v-if="resultKaryawan.gender === 'Laki-laki'"
                          >Istri</span
                        ><span
                          class="app-title-small text-sm ma-0"
                          v-if="resultKaryawan.gender === 'Perempuan'"
                          >Suami</span
                        ><span class="app-title-small text-sm ma-0" v-else
                          >Suami/Istri</span
                        >
                      </p>
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="Status tanggungan istri atau suami"
                        rules="required"
                      >
                        <v-select
                          dense
                          :items="leavingList"
                          :error-messages="errors"
                          item-text="text"
                          item-value="id"
                          v-model="dependentWife"
                          :disabled="showEdit === false"
                          outlined
                        ></v-select>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="6" lg="6" md="6" sm="6" xs="6" class="">
                      <p class="app-title-small text-sm ma-0">
                        <span
                          class="app-title-small text-sm ma-0"
                          v-if="resultKaryawan.gender === 'Laki-laki'"
                          >Istri</span
                        ><span
                          class="app-title-small text-sm ma-0"
                          v-if="resultKaryawan.gender === 'Perempuan'"
                          >Suami</span
                        ><span class="app-title-small text-sm ma-0" v-else
                          >Suami/Istri</span
                        >
                        masih Hidup?
                      </p>
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="wife or husband Alive"
                        rules="required"
                      >
                        <v-select
                          dense
                          :items="aliveList"
                          :error-messages="errors"
                          item-text="text"
                          item-value="id"
                          v-model="aliveWife"
                          :disabled="showEdit === false"
                          outlined
                        ></v-select>
                      </ValidationProvider>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      class="py-0"
                    >
                      <v-alert
                        border="left"
                        colored-border
                        color="yellow"
                        elevation="2"
                      >
                        Apakah sudah memiliki anak<br />
                        <v-btn
                          @click.prevent="buttonAct = true"
                          color="primary"
                          class="text-center mx-1"
                          dark
                          disabled
                          :outlined="!buttonAct"
                          rounded
                          x-small
                        >
                          <span class="text-capitalize">Ya</span>
                        </v-btn>
                        <v-btn
                          @click.prevent="buttonAct = false"
                          color="#008ef8"
                          class="text-center mx-1"
                          dark
                          :outlined="buttonAct"
                          disabled
                          rounded
                          x-small
                        >
                          <span class="text-capitalize">Tidak</span>
                        </v-btn>
                      </v-alert>
                    </v-col>
                    <v-col
                      cols="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      class="py-0"
                      v-if="buttonAct"
                    >
                      <v-card
                        class="pa-3 ma-2"
                        :key="index.id"
                        v-for="(row, index) in childDynamic"
                      >
                        <v-card-title>
                          <div class="w-full d-flex justify-space-between">
                            <p>Anak ke - {{ index + 1 }}</p>

                            <v-btn
                              :disabled="id_child[index] !== 0"
                              icon
                              color="red"
                              @click.prevent="removeConfigurationRow(index)"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </div>
                          <v-divider></v-divider>
                        </v-card-title>
                        <v-card-text>
                          <v-row>
                            <v-col
                              cols="12"
                              lg="7"
                              md="7"
                              sm="7"
                              xs="12"
                              class="py-0"
                            >
                              <p class="app-title-small text-sm ma-0">
                                Nama Anak
                              </p>
                              <ValidationProvider
                                v-slot="{ errors }"
                                :name="'Nama Anak ke ' + [index + 1]"
                                rules="required"
                              >
                                <v-text-field
                                  v-model="nameChild[index]"
                                  single-line
                                  :disabled="showEdit === false"
                                  :error-messages="errors"
                                  dense
                                  outlined
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="6"
                              lg="2"
                              md="2"
                              sm="2"
                              xs="6"
                              class="py-0"
                            >
                              <p class="app-title-small text-sm ma-0">
                                Jenis Kelamin
                              </p>
                              <ValidationProvider
                                v-slot="{ errors }"
                                :name="'Jenis Kelamin ' + [index + 1]"
                                rules="required"
                              >
                                <v-select
                                  dense
                                  :items="genderList"
                                  :error-messages="errors"
                                  item-text="text"
                                  item-value="id"
                                  v-model="gender[index]"
                                  :disabled="showEdit === false"
                                  outlined
                                ></v-select>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="6"
                              lg="3"
                              md="3"
                              sm="3"
                              xs="6"
                              class="py-0"
                            >
                              <p class="app-title-small text-sm ma-0">
                                Tanggal Lahir
                              </p>
                              <v-menu
                                v-model="menuChild[index]"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <ValidationProvider
                                    v-slot="{ errors }"
                                    :name="
                                      'Tanggal Lahir anak ke-' + [index + 1]
                                    "
                                    rules=""
                                  >
                                    <v-text-field
                                      v-model="dateBirthChild[index]"
                                      append-icon="mdi-calendar"
                                      :error-messages="errors"
                                      readonly
                                      single-line
                                      dense
                                      :filled="showEdit === false"
                                      outlined
                                      v-on="on"
                                    ></v-text-field>
                                  </ValidationProvider>
                                </template>
                                <v-date-picker
                                  v-model="dateBirthChild[index]"
                                  :disabled="showEdit === false"
                                  @input="menuChild[index] = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col
                              cols="6"
                              lg="4"
                              md="4"
                              sm="4"
                              xs="6"
                              class="py-0"
                            >
                              <p class="app-title-small text-sm ma-0">
                                Status Pekerjaan
                              </p>
                              <ValidationProvider
                                v-slot="{ errors }"
                                :name="
                                  'Status Pekerjaan anak ke-' + [index + 1]
                                "
                                rules="required"
                              >
                                <v-select
                                  dense
                                  :items="statusList"
                                  :error-messages="errors"
                                  item-text="text"
                                  item-value="text"
                                  v-model="status_employee[index]"
                                  :disabled="showEdit === false"
                                  outlined
                                ></v-select>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="6"
                              lg="4"
                              md="4"
                              sm="4"
                              xs="6"
                              class="py-0"
                            >
                              <p class="app-title-small text-sm ma-0">
                                Status Pernikahan
                              </p>
                              <ValidationProvider
                                v-slot="{ errors }"
                                :name="
                                  'Status Pernikahan anak ke-' + [index + 1]
                                "
                                rules="required"
                              >
                                <v-select
                                  dense
                                  :items="['Menikah', 'Tidak Menikah']"
                                  :error-messages="errors"
                                  item-text="name"
                                  :disabled="showEdit === false"
                                  item-value="id"
                                  v-model="marital[index]"
                                  outlined
                                ></v-select>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="6"
                              lg="3"
                              md="3"
                              sm="3"
                              xs="6"
                              class="py-0"
                              v-if="marital[index] !== 'Tidak Menikah'"
                            >
                              <p class="app-title-small text-sm ma-0">
                                Tanggal Menikah
                              </p>
                              <v-menu
                                v-model="menuChild1[index]"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <ValidationProvider
                                    v-slot="{ errors }"
                                    :name="
                                      'Tanggal Menikah/Cerai anak ke-' +
                                        [index + 1]
                                    "
                                    rules=""
                                  >
                                    <v-text-field
                                      v-model="dateMeriet[index]"
                                      append-icon="mdi-calendar"
                                      :error-messages="errors"
                                      readonly
                                      single-line
                                      dense
                                      :filled="showEdit === false"
                                      outlined
                                      v-on="on"
                                    ></v-text-field>
                                  </ValidationProvider>
                                </template>
                                <v-date-picker
                                  v-model="dateMeriet[index]"
                                  :disabled="showEdit === false"
                                  @input="menuChild1[index] = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col
                              cols="6"
                              lg="4"
                              md="4"
                              sm="4"
                              xs="6"
                              class="py-0"
                            >
                              <p class="app-title-small text-sm ma-0">
                                Apakah Masih Hidup?
                              </p>
                              <ValidationProvider
                                v-slot="{ errors }"
                                :name="'Status anak ke-' + [index + 1]"
                                rules="required"
                              >
                                <v-select
                                  dense
                                  :items="aliveList"
                                  :error-messages="errors"
                                  item-text="text"
                                  item-value="id"
                                  v-model="aliveChild[index]"
                                  :disabled="showEdit === false"
                                  outlined
                                ></v-select>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                      <!-- <v-btn
                          width="100%"
                          @click="addConfigurationRow(index)"
                          color="primary"
                          class="text-center mt-3"
                          dark
                          block
                        >
                          Tambah Data Anak
                        </v-btn> -->
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>
          <div
            class="mx-3 d-flex flex-row justify-space-between border-bottom pt-4"
          >
            <h1 class="title pt-5"></h1>
            <v-btn
              to="/tax-status"
              color="#2dceb7"
              class="text-center mt-5 mx-2"
              dark
              large
            >
              <span class="text-capitalize">Back</span>
            </v-btn>
            <!-- <div class="action-add d-flex flex-row">
                <v-btn
                  v-if="showEdit === false"
                  @click.prevent="showEdit = true"
                  color="#2dceb7"
                  class="text-center mt-5 mx-2"
                  dark
                  large
                >
                  <span class="text-capitalize">Edit</span>
                </v-btn>
                <v-btn
                  v-if="showEdit === true"
                  @click.prevent="showEdit = false"
                  color="#fed709"
                  class="text-center mt-5 mx-2"
                  dark
                >
                  <span class="text-capitalize">Cancel</span>
                </v-btn>
                <v-btn
                  v-if="showEdit === true"
                  type="submit"
                  color="#008ef8"
                  class="text-center mt-5 mx-2"
                  dark
                >
                  <span class="text-capitalize">Save</span>
                </v-btn>
              </div> -->
          </div>
        </v-form>
      </ValidationObserver>
    </v-card>
    <!-- dialog success -->
    <v-dialog v-model="dialog" persistent max-width="350">
      <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
        <v-icon color="green" size="100px">mdi-checkbox-marked-circle</v-icon>
        <v-card-title class="title-card mx-auto text-center"
          >Update Family <br />Success</v-card-title
        >
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            @click.prevent="closeSuccessNavigate"
            color="green"
            :loading="loading"
            class="mt-3 w-full"
            width="100%"
            dark
          >
            <span class="text-capitalize">Okay</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- dialog failed -->
    <v-dialog v-model="dialog2" persistent max-width="350">
      <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
        <v-icon color="#F32626" size="100px">mdi-alert-circle-outline</v-icon>
        <v-card-title class="title-card mx-auto text-center"
          >Update Family <br />Failed</v-card-title
        >
        <p class="mx-auto">{{ errorMessage }}</p>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            @click.prevent="dialog2 = false"
            color="green"
            class="mt-3 w-full"
            width="100%"
            dark
          >
            <span class="text-capitalize">Okay</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { createNamespacedHelpers } from "vuex";
const masterUser = createNamespacedHelpers("masterUser");
const karyawan = createNamespacedHelpers("karyawan");
export default {
  components: {},
  computed: {
    ...masterUser.mapState([
      "resFamily",
      "res_loc",
      "list_location",
      "listProvinsi",
      "listCity",
      "listDistrict",
      "listSubDistrict"
    ]),
    ...karyawan.mapState(["marital_status", "resultKaryawan"])
  },
  mounted() {
    this.temp_user = JSON.parse(Cookies.get("userdata_login"));
    this.$store.commit("masterUser/SET_USERID", this.$route.params.id);
    this.$store.dispatch("karyawan/getKaryawanById2");
    this.$store.dispatch("masterUser/getFamily");
    this.$store.dispatch("masterUser/getProvince");
    this.$store.dispatch("karyawan/getMaritalStatus");
    if (
      this.temp_user.data.marital_status !== null ||
      parseInt(this.temp_user.data.marital_status) !== 11 ||
      parseInt(this.temp_user.data.marital_status) !== 12 ||
      parseInt(this.temp_user.data.marital_status) !== 23 ||
      parseInt(this.temp_user.data.marital_status) !== 34
    ) {
      this.buttonAct = false;
    }
  },
  data() {
    return {
      menu: false,
      menu2: false,
      menu3: false,
      menuChild: [],
      menuChild1: [],
      datebirth: null,
      dateMeriet: [],
      switch1: false,
      showEdit: false,
      buttonAct: false,
      dialog2: false,
      dialog: false,
      statusList: [
        {
          text: "Bekerja"
        },
        {
          text: "Tidak Bekerja"
        },
        {
          text: "Pelajar"
        }
      ],
      leavingList: [
        {
          id: 1,
          text: "Di Tanggung"
        },
        {
          id: 0,
          text: "Tidak di tanggung"
        }
      ],
      genderList: [
        {
          id: 0,
          text: "Laki-laki"
        },
        {
          id: 1,
          text: "Perempuan"
        }
      ],
      aliveList: [
        {
          id: 1,
          text: "Ya"
        },
        {
          id: 0,
          text: "Tidak"
        }
      ],
      // data model
      id_father: "",
      fathername: "",
      fatherdate: "",
      addressFather: "",
      dependentFather: "",
      aliveFather: "",
      // mother
      id_mother: "",
      mothername: "",
      motherdate: "",
      addressmother: "",
      dependentMother: "",
      aliveMother: "",
      // wife
      id_wife: "",
      wifename: "",
      wifedate: "",
      dependentWife: "",
      aliveWife: "",
      // child
      id_child: [],
      childDynamic: [],
      relation: [],
      nameChild: [],
      dependentChild: [],
      childOrder: [],
      dateBirthChild: [],
      errorMessage: false,
      loading: false,
      create_new: "",
      temp_id: "",
      temp_create_new: "",
      temp_wife: "",
      create_new_married: "",
      temp_user: [],
      child: [],
      menu_id: [],
      gender: [],
      temp_create_new_child: [],
      marital: [],
      status_employee: [],
      districtFather: null,
      stateFather: null,
      cityFather: null,
      subdistrictFather: null,
      rtFather: null,
      rwFather: null,
      districtMother: null,
      stateMother: null,
      cityMother: null,
      subdistrictMother: null,
      rtMother: null,
      rwMother: null,
      search: null,
      isLoading2: false,
      isLoading: false,
      search2: null,
      aliveChild: [],
      isRequired: true
    };
  },
  watch: {
    stateFather(val) {
      this.$store.commit("masterUser/SET_PROVINSI", val);
      this.$store.dispatch("masterUser/getCity");
    },
    cityFather(val) {
      this.$store.commit("masterUser/SET_CITY", val);
      this.$store.dispatch("masterUser/getDistrict");
    },
    districtFather(val) {
      this.$store.commit("masterUser/SET_DISCTRICT", val);
      this.$store.dispatch("masterUser/getSubDisctrict");
    },
    stateMother(val) {
      this.$store.commit("masterUser/SET_PROVINSI", val);
      this.$store.dispatch("masterUser/getCity1");
    },
    cityMother(val) {
      this.$store.commit("masterUser/SET_CITY", val);
      this.$store.dispatch("masterUser/getDistrict1");
    },
    districtMother(val) {
      this.$store.commit("masterUser/SET_DISCTRICT", val);
      this.$store.dispatch("masterUser/getSubDisctrict1");
    },
    resFamily(newval) {
      if (newval.length > 0) {
        newval.forEach(data => {
          if (data.relationship === "Father") {
            this.temp_create_new = 0;
            this.id_father = data.id;
            this.fathername = data.name;
            this.fatherdate = data.date_birth;
            this.addressFather = data.address;
            this.dependentFather = parseInt(data.dependent_status);
            this.aliveFather = data.alive;
            this.stateFather = data.state;
            this.cityFather = data.city;
            this.districtFather = data.district;
            this.subdistrictFather = {
              sub_district: data.sub_district,
              zip_code: data.zipcode
            };
            this.rtFather = data.rt;
            this.rwFather = data.rw;
          } else if (data.relationship === "Mother") {
            this.temp_create_new = 0;
            this.id_mother = data.id;
            this.mothername = data.name;
            this.motherdate = data.date_birth;
            this.addressmother = data.address;
            this.dependentMother = parseInt(data.dependent_status);
            this.aliveMother = data.alive;
            this.stateMother = data.state;
            this.cityMother = data.city;
            this.districtMother = data.district;
            this.subdistrictMother = {
              sub_district: data.sub_district,
              zip_code: data.zipcode
            };
            this.rtMother = data.rt;
            this.rwMother = data.rw;
          } else if (data.relationship === "Wife") {
            this.switch1 = true;
            this.id_wife = data.id;
            this.wifename = data.name;
            this.wifedate = data.date_birth;
            this.dependentWife = parseInt(data.dependent_status);
            this.aliveWife = data.alive;
          } else if (data.relationship === "Children") {
            this.buttonAct = true;
            this.id_child.push(data.id);
            this.childDynamic.push(data);
            this.relation.push(data.relationship);
            this.nameChild.push(String(data.name));
            this.dateBirthChild.push(data.date_birth);
            this.status_employee.push(data.job_status);
            this.marital.push(data.status_pernikahan);
            this.dateMeriet.push(data.marital_date);
            this.dependentChild.push(parseInt(data.dependent_status));
            this.childOrder.push(data.child_order);
            this.gender.push(data.gender);
            this.temp_create_new_child.push(0);
            this.aliveChild.push(data.alive);
          }
        });
      } else {
        this.temp_create_new_child.push(1);
        this.create_new_married = 1;
        this.temp_create_new = 1;
        this.temp_id = "99999a";
      }
    }
  },
  methods: {
    handleEdit() {
      this.showEdit = true;
    },
    addConfigurationRow: function(i) {
      this.childDynamic.push([i]);
      this.temp_create_new_child.push(1);
      this.id_child.push(0);
    },
    closeSuccessNavigate() {
      this.dialog = false;
      setTimeout(() => {
        this.$router.push("/dashboard");
      }, 200);
    },
    removeConfigurationRow: function(index) {
      this.childDynamic.splice(index, 1);
      this.relation.splice(index, 1);
      this.nameChild.splice(index, 1);
      this.dateBirthChild.splice(index, 1);
      this.menuChild.splice(index, 1);
      this.dependentChild.splice(index, 1);
      this.childOrder.splice(index, 1);
      this.genderList.splice(index, 1);
      this.status_employee.splice(index, 1);
      this.marital.splice(index, 1);
      this.dateMeriet.splice(index, 1);
    },
    submitForm() {
      if (this.id_wife === "") {
        this.create_new_married = 1;
        this.id_wife = 0;
      } else if (this.id_wife !== "") {
        this.create_new_married = 0;
      }
      if (this.fatherdate === "") {
        this.fatherdate = null;
      }
      if (this.motherdate === "") {
        this.motherdate = null;
      }
      this.menu_id.push(
        {
          id: this.$route.params.id,
          emp_no: this.temp_user.data.emp_no,
          gender: 1,
          name: this.fathername,
          relationship: "Father",
          child_order: 0,
          dependent_status: this.dependentFather,
          alive: this.aliveFather,
          birth_date: this.fatherdate,
          address: this.addressFather,
          state: null,
          city: null,
          district: null,
          subdistrict: null,
          zip: null,
          rt: null,
          rw: null,
          id_update: this.id_father,

          marital_date: null,
          marital_status: null,
          job_status: null
        },
        {
          id: this.$route.params.id,
          emp_no: this.temp_user.data.emp_no,
          gender: 0,
          name: this.mothername,
          relationship: "Mother",
          child_order: 0,
          dependent_status: this.dependentMother,
          alive: this.aliveMother,
          birth_date: this.motherdate,
          address: this.addressmother,
          state: null,
          city: null,
          district: null,
          subdistrict: null,
          zip: null,
          rt: null,
          rw: null,
          id_update: this.id_mother,
          marital_date: null,
          marital_status: null,
          job_status: null
        }
      );
      var tempProduct = {};
      tempProduct.create_new = this.temp_create_new;

      if (this.switch1 === true) {
        tempProduct.status_married = 1;
        tempProduct.name_married = this.wifename;
        tempProduct.create_new_married = this.create_new_married;
        tempProduct.id_user_married = this.$route.params.id;
        tempProduct.emp_no_married = this.temp_user.data.emp_no;
        tempProduct.gender_married = 1;
        tempProduct.relationship_married = "Wife";
        tempProduct.child_order_married = 0;
        tempProduct.dependent_status_married = this.dependentWife;
        tempProduct.alive_married = this.aliveWife;
        tempProduct.birth_date_married = this.wifedate;
        tempProduct.address_married = 0;
        tempProduct.id_update_married = this.id_wife;
      }
      if (this.buttonAct === true) {
        tempProduct.status_child = 1;
        this.childDynamic.forEach((data, index) => {
          this.child.push({
            id: this.$route.params.id,
            emp_no: this.temp_user.data.emp_no,
            gender: this.gender[index],
            name: this.nameChild[index],
            birth_date: this.dateBirthChild[index],
            marital_date: this.dateMeriet[index],
            marital_status: this.marital[index],
            job_status: this.status_employee[index],
            relationship: "Children",
            child_order: index + 1,
            dependent_status: this.dependentChild[index],
            alive: this.aliveChild[index],
            address: 0,
            id_update: this.id_child[index],
            create_new_child: this.temp_create_new_child[index]
          });
        });
        tempProduct.child = JSON.stringify(this.child);
      }
      tempProduct.menu_id = JSON.stringify(this.menu_id);
      var formData = new FormData();
      for (var key in tempProduct) {
        formData.append(key, tempProduct[key]);
      }
      this.$store.commit("masterUser/SET_USERIDUPDATE", this.$route.params.id);
      this.$store.commit("masterUser/SET_FAMILYUPDATE", formData);
      this.$store
        .dispatch("masterUser/updateFamily")
        .then(response => {
          const res = response.data;
          if (res.status) {
            this.dialog = true;
            this.loading = false;
          } else {
            this.dialog2 = true;
            this.loading = false;
          }
        })
        .catch(error => {
          const message = error.response.data.message;
          this.errorMessage = message;
          this.dialog2 = true;
          this.loading = false;
        });
    }
  }
};
</script>
<style scoped></style>
